import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Row, TextButton } from 'seagull';
export const ProposalActionsRow = (param)=>{
    let { selectedCount, applySelectedLabel, applyAllLabel, dismissLabel, applySelectedDisabled, onApplySelected, onApplyAll, onDismiss, dismissTestId, applySelectedTestId, applyAllTestId, className } = param;
    const showApplyAll = applyAllLabel != null && onApplyAll != null;
    return /*#__PURE__*/ _jsxs(Row, {
        gap: 8,
        alignItems: "center",
        justifyContent: "space-between",
        className: className,
        children: [
            /*#__PURE__*/ _jsx(TextButton, {
                underline: "none",
                weight: "normal",
                testId: dismissTestId,
                onClick: onDismiss,
                children: dismissLabel
            }),
            /*#__PURE__*/ _jsxs(Row, {
                gap: 8,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        bi: {
                            name: 'apply_selected_agent_proposals'
                        },
                        skin: "primaryOutline",
                        disabled: applySelectedDisabled,
                        testId: applySelectedTestId,
                        onClick: onApplySelected,
                        children: "".concat(applySelectedLabel, " (").concat(selectedCount, ")")
                    }),
                    showApplyAll && /*#__PURE__*/ _jsx(Button, {
                        bi: {
                            name: 'apply_all_agent_proposals'
                        },
                        testId: applyAllTestId,
                        onClick: onApplyAll,
                        children: applyAllLabel
                    })
                ]
            })
        ]
    });
};
